function normalizeDisplayText(value: string | null | undefined) {
  return (value ?? '').trim();
}

export function formatStudioRoomTitle(
  studioName: string | null | undefined,
  roomName: string | null | undefined,
): string {
  const studio = normalizeDisplayText(studioName);
  const room = normalizeDisplayText(roomName);

  if (!studio) return room;
  if (!room) return studio;
  if (room === studio || room.includes(studio)) return room;

  return `${studio}-${room}`;
}
